import React, { useState, useEffect } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const SupportButton = () => {
  const [showMenu, setShowMenu] = useState(false);
  const { tt } = useLanguage();
  const [contacts, setContacts] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSupportContacts();
  }, []);

  const fetchSupportContacts = async () => {
    try {
      const response = await axios.get(`${API}/support/contacts`);
      setContacts(response.data);
    } catch (error) {
      console.error('Error fetching support contacts:', error);
      // Fallback контакты
      setContacts({
        telegram: '@InvestedsCripto_bot',
        whatsapp: '+77754156437'
      });
    } finally {
      setLoading(false);
    }
  };

  const handleTelegramClick = () => {
    const username = contacts.telegram?.replace('@', '');
    window.open(`https://t.me/${username}`, '_blank');
  };

  const handleWhatsAppClick = () => {
    const phone = contacts.whatsapp?.replace(/[^\d]/g, '');
    window.open(`https://wa.me/${phone}`, '_blank');
  };

  if (loading || (!contacts.telegram && !contacts.whatsapp)) {
    return null;
  }

  return (
    <>
      {/* Support Button */}
      <div className="fixed bottom-6 right-6 z-50">
        {/* Support Menu */}
        {showMenu && (
          <div className="absolute bottom-16 right-0 bg-white rounded-lg shadow-2xl border border-gray-200 p-4 mb-2 min-w-[200px]">
            <div className="text-center mb-3">
              <p className="font-semibold text-gray-900">{tt('Поддержка')}</p>
              <p className="text-xs text-gray-500">{tt('Выберите способ связи')}</p>
            </div>
            <div className="space-y-2">
              {/* Telegram Button */}
              {contacts.telegram && (
                <button
                  onClick={handleTelegramClick}
                  className="w-full flex items-center justify-center space-x-2 px-4 py-3 bg-blue-500 hover:bg-blue-600 text-white rounded-lg transition-all duration-200 transform hover:scale-105"
                >
                  <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm5.894 8.221l-1.97 9.28c-.145.658-.537.818-1.084.508l-3-2.21-1.446 1.394c-.14.18-.357.295-.6.295-.002 0-.003 0-.005 0l.213-3.054 5.56-5.022c.24-.213-.054-.334-.373-.121l-6.869 4.326-2.96-.924c-.64-.203-.658-.64.135-.954l11.566-4.458c.538-.196 1.006.128.832.941z"/>
                  </svg>
                  <span className="font-medium text-sm">Telegram</span>
                </button>
              )}
              
              {/* WhatsApp Button */}
              {contacts.whatsapp && (
                <button
                  onClick={handleWhatsAppClick}
                  className="w-full flex items-center justify-center space-x-2 px-4 py-3 bg-green-500 hover:bg-green-600 text-white rounded-lg transition-all duration-200 transform hover:scale-105"
                >
                  <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                  </svg>
                  <span className="font-medium text-sm">WhatsApp</span>
                </button>
              )}
            </div>
          </div>
        )}

        {/* Main Support Button */}
        <button
          onClick={() => setShowMenu(!showMenu)}
          className="bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700 text-white rounded-full p-4 shadow-2xl transition-all duration-200 transform hover:scale-110"
          aria-label={tt('Поддержка')}
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192l-3.536 3.536M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-5 0a4 4 0 11-8 0 4 4 0 018 0z" />
          </svg>
        </button>
      </div>

      {/* Overlay to close menu when clicking outside */}
      {showMenu && (
        <div
          className="fixed inset-0 z-40"
          onClick={() => setShowMenu(false)}
        />
      )}
    </>
  );
};

export default SupportButton;
